import React, { useEffect, useState } from "react";
import styles from "./Navbar.module.css";
// import { ReactComponent as LoginIcon } from "../assets/svg/login.svg";
import { ReactComponent as BrandLogo } from "../assets/logo_withPadding.svg";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null); // "products" | "solutions" | "resources" | null

    // Close all dropdowns if the main menu closes
    useEffect(() => {
        if (!isMenuOpen) setOpenMenu(null);
    }, [isMenuOpen]);

    const toggleMenu = (key) => {
        setOpenMenu((prev) => (prev === key ? null : key));
  };

  return (
    <nav className={styles.navbar}>
          {/* ...brand... */}

        <a href="/">
              <BrandLogo className={styles.brandLogo} />
          </a>

      <button
        className={styles.menuToggle}
              onClick={() => setIsMenuOpen((v) => !v)}
              aria-expanded={isMenuOpen}
              aria-controls="main-nav"
              aria-label="Toggle menu"
      >
        ☰
      </button>

      <ul
              id="main-nav"
              className={`${styles.navLinks} ${isMenuOpen ? styles.navLinksActive : ""}`}
          >
              {/* Products */}
              <li className={styles.dropdown}>
                  <button
                      className={styles.dropdownToggle}
                      onClick={() => toggleMenu("products")}
                      aria-expanded={openMenu === "products"}
                      aria-haspopup="true"
                  >
                      Products
                  </button>
                  <div
                      className={`${styles.dropdownMenu} ${openMenu === "products" ? styles.dropdownMenuActive : ""
                          }`}
                  >
                      {/* ...Products content... */}
                      <div className={styles.section}>
                          <div className={styles.sectionHeadingStatic}>Robotics</div>
                          <ul className={styles.submenuStatic}>
                              <li>
                                  <a href="/robotics" className={styles.submenuLink}>
                                      Overview
                                  </a>
                              </li>
                              <li>
                                  <a href="/robotics/mobile" className={styles.submenuLink}>
                                      Mobile Robots
                                  </a>
                              </li>
                              <li>
                                  <a href="/robotics/perception" className={styles.submenuLink}>
                                      Perception SDK
                                  </a>
                              </li>
                          </ul>
                      </div>

                      <div className={styles.section}>
                          <div className={styles.sectionHeadingStatic}>Finance</div>
                          <ul className={styles.submenuStatic}>
                              <li>
                                  <a href="/finance" className={styles.submenuLink}>
                                      Overview
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/finance/sp500"
                                      className={styles.submenuLink}
                                  >
                                      S&amp;P 500
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/finance/sp500/performance"
                                      className={styles.submenuLink}
                                  >
                                      S&amp;P 500 Performance
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/finance/fundamentals"
                                      className={styles.submenuLink}
                                  >
                                      Fundamental Trends
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/finance/duel"
                                      className={styles.submenuLink}
                                  >
                                      Market Cap Duel
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/finance/markets"
                                      className={styles.submenuLink}
                                  >
                                      Equity Search
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </div>
              </li>

              {/* Solutions */}
        <li className={styles.dropdown}>
                  <button
                      className={styles.dropdownToggle}
                      onClick={() => toggleMenu("solutions")}
                      aria-expanded={openMenu === "solutions"}
                      aria-haspopup="true"
                  >
                      Solutions
                  </button>
                  <div
                      className={`${styles.dropdownMenu} ${openMenu === "solutions" ? styles.dropdownMenuActive : ""
              }`}
          >
                      {/* ...Solutions content... */}
                      <div className={styles.section}>
                          <div className={styles.sectionHeadingStatic}></div>
                          <ul className={styles.submenuStatic}>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Security
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Manufacturing
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Research
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </div>
        </li>

              {/* Resources */}
              <li className={styles.dropdown}>
                  <button
                      className={styles.dropdownToggle}
                      onClick={() => toggleMenu("resources")}
                      aria-expanded={openMenu === "resources"}
                      aria-haspopup="true"
                  >
                      Resources
                  </button>
                  <div
                      className={`${styles.dropdownMenu} ${openMenu === "resources" ? styles.dropdownMenuActive : ""
                          }`}
                  >
                      {/* ...Resources content... */}
                      <div className={styles.section}>
                          <div className={styles.sectionHeadingStatic}></div>
                          <ul className={styles.submenuStatic}>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Posts
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Publications
                                  </a>
                              </li>
                              <li>
                                  <a
                                      href="/"
                                      className={styles.submenuLink}
                                  >
                                      Research & White Papers
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </div>
              </li>

              {/* Static links */}
              <li><a href="/docs">Documentation</a></li>
              <li><a href="/about">Company</a></li>
              <li><a href="/login" className={styles.loginNav}>Log In</a></li>
      </ul>
    </nav>
  );
}